/* ROSHFORT - product page: group the buy controls into one box.

   The theme renders price, stock and the add-to-cart form as three separate
   siblings inside <product-info>. CSS cannot wrap elements, so this moves
   them into one <div class="rf-buybox"> that becomes a real child of
   .product--columns.

   Nothing is deleted; the elements are only re-parented. */
(function () {
  'use strict';

  function build() {
    var product = document.querySelector('.product--columns');
    if (!product || product.querySelector('.rf-buybox')) { return; }

    var info = product.querySelector('product-info.product__info');
    if (!info) { return; }

    var price = info.querySelector('.product__price');
    var stock = info.querySelector('.product__inventory');
    var form = info.querySelector('.product-form-wrapper');
    if (!price && !form) { return; }

    var box = document.createElement('div');
    box.className = 'rf-buybox';

    [price, stock, form].forEach(function (el) { if (el) { box.appendChild(el); } });
    product.appendChild(box);
  }

  /* ------------------------------------------------------------------
     BUY NOW for engraving products.

     Shopify's own "Buy it now" skips the cart, and line item properties do
     not survive that route - the customer would pay and the engraving name
     would never reach the order. So it stays switched off in
     buy-buttons.liquid for these products.

     This is our own button instead: it posts the form (name included) to
     /cart/add.js and only then sends the customer to checkout. One click for
     them, and the name is safely on the line item.
     ------------------------------------------------------------------ */
  function buyNow() {
    var input = document.querySelector('[data-rf-engrave-input]');
    if (!input) { return; }                       /* not an engraving product */
    if (document.querySelector('.rf-buy-now')) { return; }

    var add = document.querySelector('.product-form__submit[data-rf-requires-engraving]');
    if (!add) { return; }

    var formId = add.getAttribute('form');
    var form = (formId && document.getElementById(formId)) || add.closest('form');
    if (!form) { return; }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rf-buy-now';
    btn.textContent = 'BUY NOW';
    if (formId) { btn.setAttribute('form', formId); }
    add.parentNode.insertBefore(btn, add.nextSibling);

    function sync() {
      if (input.value.trim().length) { btn.removeAttribute('disabled'); }
      else { btn.setAttribute('disabled', 'disabled'); }
    }
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();

    btn.addEventListener('click', function () {
      var name = input.value.trim();
      if (!name) { input.focus(); input.style.borderColor = '#d02e2e'; return; }

      var fd = new FormData(form);
      var idEl = form.querySelector('[name="id"]');
      if (idEl && idEl.value) { fd.set('id', idEl.value); }
      if (!fd.get('properties[Engraving / Print Name]')) {
        fd.set('properties[Engraving / Print Name]', name);
      }

      var label = btn.textContent;
      btn.setAttribute('disabled', 'disabled');
      btn.textContent = 'ONE MOMENT...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart');
          }
          window.location.href = '/checkout';
        })
        .catch(function (e) {
          btn.removeAttribute('disabled');
          btn.textContent = label;
          var box = form.querySelector('.product-form__error-message');
          if (box) { box.hidden = false; box.textContent = e.message; }
        });
    });
  }

  /* ------------------------------------------------------------------
     "Need help?" was an <a> with no href, so clicking it did nothing.
     Point it at the ROSHFORT support chat already on the page. If the chat
     has not loaded, fall back to WhatsApp rather than a dead link.
     ------------------------------------------------------------------ */
  function needHelp() {
    var all = document.querySelectorAll('a, button, summary');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.getAttribute('data-rf-help-wired')) { continue; }
      if (!/^\s*need\s*help\??\s*$/i.test(el.textContent || '')) { continue; }
      el.setAttribute('data-rf-help-wired', '1');
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        var root = document.getElementById('rsf-chat-root');
        var b = root && root.querySelector('button');
        if (b) { b.click(); return; }
        window.location.href = 'https://wa.me/919631056748';
      });
    }
  }

  /* ------------------------------------------------------------------
     Share row: drop the e-mail option. It opens a desktop mail client, which
     most Indian shoppers do not have set up, so it looked broken. WhatsApp,
     Facebook, X and Pinterest stay.

     Scoped to the share list only (.social-sharing). The footer contact
     address and any info@roshfort.com written inside a product description
     are real addresses and are left alone.
     ------------------------------------------------------------------ */
  function dropMailShare() {
    var mails = document.querySelectorAll('.social-sharing a[href^="mailto:"], a.social-sharing__link[href^="mailto:"]');
    for (var i = 0; i < mails.length; i++) {
      var a = mails[i];
      var item = a.closest('li') || a;
      if (item.parentNode) { item.parentNode.removeChild(item); }
    }
  }

  function runAll() {
    build();
    buyNow();
    needHelp();
    dropMailShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  /* Shopify re-renders the section on a variant change or a theme-editor
     update, which puts the originals back where they were. */
  document.addEventListener('shopify:section:load', runAll);
})();